import type {AskFormState} from '../hooks/useAskModal';
import {toAssetAmount} from './format';

export const buildCreatePayload = (state: AskFormState) => ({
  volume: toAssetAmount(state.volume),
  quote: toAssetAmount(state.quote),
  ...(state.minBidVolume ? {minBidVolume: state.minBidVolume} : {}),
  ...(state.maxAllowedOfferPrice
    ? {maxAllowedOfferPrice: state.maxAllowedOfferPrice}
    : {}),
  ...(state.expiresAt ? {expiresAt: state.expiresAt} : {}),
});

export const buildUpdatePayload = (state: AskFormState) =>
  buildCreatePayload(state);
